
import React from 'react';
import { connect } from 'react-redux';
import SVGComponent from '../SVG/SVGComponent';
import { SVG_ICONS, BOOKING_TYPE } from '../../constants';
import { extractDate, getDateTime } from '../../utils/common';
import { getTimezone } from '../../selectors/common';
import TennisEventsModal from '../../containers/Events/Tennis/TennisEventsModal';
import EventsModal from '../../containers/Events/Soccer/EventsModal';

const mapToProps = (state) => ({
  getTimezone: getTimezone(state),
});

/**
 * @module Modals/ConfirmationModal
 */
/**
 * @typedef {object} props
 * @property {object} modalData
 * @property {string} modalData.heading
 * @property {string} modalData.title
 * @property {Array} modalData.additionalMessages
 * @property {Function} cancel
 * @property {Function} confirmation
 */

/**
 * @param {props} props
 * @returns {view}
 */
const EventSelectionModal = (props) => {
  const getDate = (startDateTime) => {
    const dateTime = getDateTime(startDateTime, props.getTimezone);
    return extractDate(dateTime);
  };
  const getTime = (dateTime) => {
    const timeArr = dateTime?.split('T')[1]?.split(':');
    return timeArr?.length > 1 ? `${timeArr[0]}:${timeArr[1]}` : '';
  };

  return (
    <div className="dialog dialog--selection">
      <div className="dialog__heading">
        <span className="dialog__title">
          {BOOKING_TYPE[props.bookingType]}
          {' '}
          - Event Selection
        </span>
        {' '}
        <SVGComponent
          onClick={props.cancel}
          className="icon-xxs  dialog__close"
          src={`${SVG_ICONS.utility}#close`}
        />
      </div>
      <div className="dialog__content">
        <div className="table-responsive fix-selection">
          {props.isTennis
            ? (
              <TennisEventsModal
                matches={props.matches}
                getDate={getDate}
                getTime={getTime}
              />
            )
            : (
              <EventsModal
                matches={props.matches}
                getDate={getDate}
                getTime={getTime}
                leagues={props.leagues}
              />
            )}
        </div>
      </div>
      <div className="dialog__btn-wrap">
        <button type="button" className="btn btn-secondary" onClick={props.cancel} id="cancel_EventSelectionModal">Cancel</button>
        {' '}
        <button type="button" className="btn btn-primary m-l-10" onClick={props.confirmation} id="confirm_EventSelectionModal">Confirm</button>
      </div>
    </div>
  );
};

export default connect(mapToProps)(EventSelectionModal);
